import { AppConfigIpWhiteList, AppConfigNames } from "@lib/types/AppConfig";
import { useIntl } from "react-intl";
import { Button, Form, Input } from "antd";
import { StyledFlex } from "@lib/components/MiniComponents/Table/index.styled";
import { createYupSync } from "@lib/helpers/TableHelper";
import { ipWhiteListSchema } from "@lib/schemas/appConfig";
import { AppLoader, AppsContainer } from "@lib/components/AppComponents";
import { useQuery } from "@tanstack/react-query";
import { apiGetAppConfigs } from "@lib/api/settings";
import { useAppConfigQueries } from "@lib/apiQueries";

const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 18 },
};

const configName = AppConfigNames.appRestrictionConfig;

export default function AppRestrictionConfig() {
  const [form] = Form.useForm();
  const { messages } = useIntl();

  const { data, isLoading, isPending, refetch } = useQuery({
    queryFn: () =>
      apiGetAppConfigs({
        filter: [`name||eq||${configName}`],
      }),
    queryKey: ["app-config", configName],
  });

  const { updateAppConfigMutation } = useAppConfigQueries({
    messages,
    params: {
      sort: "createdAt,DESC",
    },
  });

  const loading = isLoading || isPending;
  const configId = data?.data?.data[0]?.id;
  const apiData =
    (data?.data?.data[0]?.data as AppConfigIpWhiteList)?.ipWhiteList || [];

  if (loading) return <AppLoader />;

  return (
    <AppsContainer
      fullView
      cardBg
      title={messages["sidebar.appRestrictionConfig"] as string}
      cardStyle={{
        padding: 20,
      }}
      cardProps={{
        borderFull: true,
      }}
    >
      <Form
        {...layout}
        form={form}
        initialValues={{ ipWhiteList: apiData.join("\n") }}
        onFinish={async (values: any) => {
          await updateAppConfigMutation.mutateAsync({
            id: configId,
            data: {
              ipWhiteList: values.ipWhiteList.split("\n"),
            },
          });
          refetch();
        }}
      >
        <Form.Item
          name={"ipWhiteList"}
          label={messages["common.ipWhiteList"] as string}
          rules={[createYupSync({ schema: ipWhiteListSchema })]}
        >
          <Input.TextArea rows={20} />
        </Form.Item>

        <StyledFlex style={{ justifyContent: "end" }}>
          <Button
            variant="outlined"
            type="primary"
            htmlType="submit"
            disabled={loading}
            loading={loading}
          >
            {messages["common.save"] as string}
          </Button>
        </StyledFlex>
      </Form>
    </AppsContainer>
  );
}
